import { createStore } from 'vuex'
import { auth } from './auth.module'
import { providerStore } from './provider.module'
import main from './main'
import sideMenu from './side-menu'
import employeeMenu from './employee-menu'
import simpleMenu from './simple-menu'
import topMenu from './top-menu'

const store = createStore({
  modules: {
    main,
    sideMenu,
    employeeMenu,
    simpleMenu,
    topMenu,
    auth,
    providerStore
  }
})

export function useStore() {
  return store
}

export default store
